import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=c23dc874&scoped=true&"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23dc874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23dc874')) {
      api.createRecord('c23dc874', component.options)
    } else {
      api.reload('c23dc874', component.options)
    }
    module.hot.accept("./ProfileDropdown.vue?vue&type=template&id=c23dc874&scoped=true&", function () {
      api.rerender('c23dc874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ProfileDropdown.vue"
export default component.exports